import { render, staticRenderFns } from "./contest-quiz-feedback.html?vue&type=template&id=124f914f&scoped=true&"
import script from "./contest-quiz-feedback.js?vue&type=script&lang=js&"
export * from "./contest-quiz-feedback.js?vue&type=script&lang=js&"
import style0 from "./contest-quiz-feedback.scss?vue&type=style&index=0&id=124f914f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f914f",
  null
  
)

export default component.exports